import React from 'react';
import ReactTooltip from 'react-tooltip';
import { IProps } from './interfaces';
import {
  SearchResultsContainer,
  Container,
  TableContainer,
  Separator,
} from './styles';
import ExchangeInfoBar from './InfoBar/component';
import ExchangeSearchResultsTable from './ResultsTable/component';
import ExchangeAssetDetails from './AssetDetails/component';

export default class ExchangeSearchResults extends React.Component<IProps> {
  render() {
    return (
      <SearchResultsContainer>
        <Container>
          <TableContainer>
            <ExchangeInfoBar />
            <ExchangeSearchResultsTable />
          </TableContainer>
          <Separator />
          <ExchangeAssetDetails />
        </Container>
        <ReactTooltip
          id="share-tooltip"
          delayShow={250}
          effect="solid"
        />
      </SearchResultsContainer>
    );
  }
}
